import { gql } from '@apollo/client';

import { MEDIA_FRAGMENT } from './mediaFragment';
import { ROLE_FRAGMENTS } from './roleFragment';
import { USER_ROLE_FRAGMENT } from './userRoleFragment';

export const USER_BASIC_FIELDS_FRAGMENT = gql`
  fragment UserBasicFields on User {
    id
    email
    firstName
    lastName
    fullName
    createdAt
    updatedAt
  }
`;

export const USER_FRAGMENTS = gql`
  fragment UserFields on User {
    ...UserBasicFields
    description
    isEmailVerified
    status
    deletedAt
    avatar {
      ...MediaFields
    }
    organizationId
    lastLoginAt
    roles {
      ...RoleFields
    }
  }
  ${USER_BASIC_FIELDS_FRAGMENT}
  ${MEDIA_FRAGMENT}
  ${ROLE_FRAGMENTS}
`;

/** User shape used by user detail pages where role assignment data is required. */
export const USER_DETAIL_FRAGMENTS = gql`
  fragment UserDetailFields on User {
    ...UserFields
    roles {
      ...RoleFields
    }
    userRoles {
      ...UserRoleFields
    }
  }
  ${USER_FRAGMENTS}
  ${ROLE_FRAGMENTS}
  ${USER_ROLE_FRAGMENT}
`;
